<template>
  <div class="finance-payment-exclude-projects">
    <div class="filters-section">
      <div class="filters-row">
        <div class="filter-item filter-item--grow">
          <label>Фильтр (проект):</label>
          <div class="filter-with-clear">
            <div class="filter-input-wrapper filter-input-wrapper--grow" @click="openFilterProjectModal">
              <q-input
                :model-value="filterProjectLabel"
                outlined
                dense
                readonly
                placeholder="Все проекты"
                class="project-input project-input--grow"
              >
                <template v-slot:prepend>
                  <q-icon name="filter_alt" color="grey-7" />
                </template>
              </q-input>
            </div>
            <q-btn
              v-if="filters.project_id"
              flat
              round
              dense
              icon="close"
              size="sm"
              color="grey-7"
              class="clear-btn"
              @click="clearFilterProject"
            />
          </div>
        </div>

        <div class="filter-item">
          <label>Показать:</label>
          <q-toggle
            v-model="filters.only_active"
            color="deep-orange-6"
            label="Только активные исключения"
            dense
          />
        </div>

        <div class="filter-actions">
          <q-btn
            color="primary"
            icon="refresh"
            label="Обновить"
            :loading="isFetching"
            @click="getData"
          />
          <q-btn color="grey-7" flat label="Сбросить" @click="resetFilters" />
          <q-btn
            outline
            color="grey-8"
            icon="arrow_back"
            label="Назад"
            @click="goBack"
          />
        </div>
      </div>
    </div>

    <div class="create-section">
      <div class="create-title">
        <q-icon name="block" color="deep-orange-6" class="q-mr-sm" />
        <span>Добавить исключение</span>
      </div>

      <div class="create-row">
        <div class="filter-item filter-item--grow">
          <label>Проект для исключения:</label>
          <div class="filter-with-clear">
            <div class="filter-input-wrapper filter-input-wrapper--grow" @click="openCreateProjectModal">
              <q-input
                :model-value="createProjectLabel"
                outlined
                dense
                readonly
                placeholder="Выберите проект"
                class="project-input project-input--grow"
              >
                <template v-slot:prepend>
                  <q-icon name="apartment" color="primary" />
                </template>
              </q-input>
            </div>
            <q-btn
              v-if="createForm.project_id"
              flat
              round
              dense
              icon="close"
              size="sm"
              color="grey-7"
              class="clear-btn"
              @click="clearCreateProject"
            />
          </div>
        </div>

        <div class="filter-item">
          <label>Дата исключения:</label>
          <q-input v-model="createForm.exclude_date" type="date" outlined dense />
        </div>

        <div class="filter-item filter-item--grow">
          <label>Комментарий:</label>
          <q-input v-model="createForm.exclude_comment" outlined dense placeholder="Причина / примечание" />
        </div>

        <div class="filter-actions">
          <q-btn
            color="deep-orange-6"
            icon="block"
            label="Исключить"
            :disable="!createForm.project_id"
            :loading="isCreating"
            @click="createExclude"
          />
        </div>
      </div>
    </div>

    <div class="table-section">
      <CustomTable
        :title="tableTitle"
        :rowsData="rowsDataFiltered"
        :columns="columns"
        :loading="isFetching"
        :custom-body="true"
        :show-search="true"
      >
        <template #customBody="props">
          <q-tr :props="props">
            <q-td key="project_info" :props="props">
              <div class="project-info-cell">
                <div class="project-name-row">
                  <q-icon name="apartment" color="primary" size="xs" class="q-mr-xs" />
                  <span class="resident-name">{{ props.row.resident_name || "—" }}</span>
                </div>
                <div class="project-details-row">
                  <q-badge color="blue-grey-2" text-color="blue-grey-8" class="q-mr-sm">
                    {{ props.row.project_type_name || "Тип не указан" }}
                  </q-badge>
                  <span class="project-id">ID: {{ props.row.project_id }}</span>
                </div>
              </div>
            </q-td>

            <q-td key="exclude_info" :props="props">
              <div class="exclude-info-cell">
                <div class="exclude-line">
                  <q-icon name="event_busy" color="deep-orange-6" size="xs" class="q-mr-xs" />
                  <span class="exclude-label">с</span>
                  <span class="exclude-date">{{ formatDate(props.row.exclude_date) || "—" }}</span>
                </div>
                <div class="exclude-line">
                  <q-icon
                    :name="props.row.include_date ? 'event_available' : 'schedule'"
                    :color="props.row.include_date ? 'positive' : 'grey-6'"
                    size="xs"
                    class="q-mr-xs"
                  />
                  <span v-if="props.row.include_date" class="include-date">
                    по {{ formatDate(props.row.include_date) }}
                  </span>
                  <span v-else class="active-badge">активно</span>
                </div>
              </div>
            </q-td>

            <q-td key="exclude_comment" :props="props">
              <div class="comment-cell">{{ props.row.exclude_comment || "—" }}</div>
            </q-td>

            <q-td key="employee_fio" :props="props">
              <div class="who-cell">
                <q-icon name="person" color="grey-6" size="xs" class="q-mr-xs" />
                <span>{{ props.row.employee_fio || "—" }}</span>
              </div>
            </q-td>

            <q-td key="actions" :props="props" class="text-right">
              <div class="actions-cell">
                <q-btn
                  v-if="!props.row.include_date"
                  flat
                  dense
                  color="positive"
                  icon="check_circle"
                  @click="includeProject(props.row)"
                >
                  <q-tooltip>Включить обратно (поставить дату включения = сегодня)</q-tooltip>
                </q-btn>
                <q-btn flat dense color="primary" icon="edit" @click="openEditDialog(props.row)">
                  <q-tooltip>Редактировать</q-tooltip>
                </q-btn>
                <q-btn flat dense color="negative" icon="delete" @click="deleteExclude(props.row)">
                  <q-tooltip>Удалить</q-tooltip>
                </q-btn>
              </div>
            </q-td>
          </q-tr>
        </template>
      </CustomTable>
    </div>

    <q-dialog v-model="editDialog.isOpen" persistent>
      <q-card style="min-width: 520px; max-width: 90vw;">
        <q-card-section class="row items-center q-pb-sm">
          <div class="text-h6">Редактирование исключения</div>
          <q-space />
          <q-btn icon="close" flat round dense v-close-popup />
        </q-card-section>

        <q-card-section class="q-pt-none">
          <div class="text-caption text-grey q-mb-sm">
            Проект: {{ editDialog.projectLabel || "—" }}
          </div>
          <div class="row q-col-gutter-md">
            <div class="col-6">
              <label class="field-label">Дата исключения</label>
              <q-input v-model="editDialog.form.exclude_date" type="date" outlined dense />
            </div>
            <div class="col-6">
              <label class="field-label">Дата включения (если нужно)</label>
              <q-input v-model="editDialog.form.include_date" type="date" outlined dense />
            </div>
            <div class="col-12">
              <label class="field-label">Комментарий</label>
              <q-input v-model="editDialog.form.exclude_comment" outlined dense />
            </div>
          </div>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat color="grey-7" label="Отмена" v-close-popup />
          <q-btn
            color="primary"
            icon="save"
            label="Сохранить"
            :loading="editDialog.isSaving"
            @click="saveEdit"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import CustomTable from "@/components/common/CustomTable";
import { useAppStore } from "@/services/store/app";
import { MODAL_NAMES, PAGES } from "@/constants";
import {
  columns,
  readProjectPaymentExclude,
  createProjectPaymentExclude,
  updateProjectPaymentExclude,
  deleteProjectPaymentExclude,
} from "@/views/FinancePaymentExcludeProjects/services";

export default {
  name: "FinancePaymentExcludeProjects",
  components: { CustomTable },
  data() {
    return {
      columns,
      rowsData: [],
      isFetching: false,
      isCreating: false,
      currentDateTime: "",
      timer: null,
      selectedFilterProject: null,
      selectedCreateProject: null,
      filters: {
        project_id: null,
        only_active: true,
      },
      createForm: {
        project_id: null,
        exclude_date: "",
        exclude_comment: "",
      },
      editDialog: {
        isOpen: false,
        isSaving: false,
        projectLabel: "",
        form: {
          project_payment_exclude_id: null,
          exclude_date: "",
          include_date: "",
          exclude_comment: "",
        },
      },
    };
  },
  computed: {
    tableTitle() {
      return `Исключение проектов от оплат на ${this.currentDateTime}`;
    },
    filterProjectLabel() {
      if (!this.selectedFilterProject) return "";
      const id = this.selectedFilterProject.project_id ? `#${this.selectedFilterProject.project_id}` : "";
      const resident = this.selectedFilterProject.resident_name || "";
      const type = this.selectedFilterProject.project_type_name || "";
      return [id, resident, type].filter(Boolean).join(" — ");
    },
    createProjectLabel() {
      if (!this.selectedCreateProject) return "";
      const id = this.selectedCreateProject.project_id ? `#${this.selectedCreateProject.project_id}` : "";
      const resident = this.selectedCreateProject.resident_name || "";
      const type = this.selectedCreateProject.project_type_name || "";
      return [id, resident, type].filter(Boolean).join(" — ");
    },
    rowsDataFiltered() {
      const rows = this.rowsData || [];
      if (!this.filters.only_active) return rows;
      return rows.filter((r) => !r.include_date);
    },
  },
  mounted() {
    this.updateDateTime();
    this.timer = setInterval(this.updateDateTime, 60000);
    this.createForm.exclude_date = this.todayIsoDate();
    this.getData();
  },
  beforeUnmount() {
    if (this.timer) clearInterval(this.timer);
  },
  methods: {
    updateDateTime() {
      const now = new Date();
      this.currentDateTime = now.toLocaleString("ru-RU", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    formatDate(dateStr) {
      if (!dateStr) return "";
      const d = new Date(dateStr);
      return d.toLocaleDateString("ru-RU");
    },
    todayIsoDate() {
      const now = new Date();
      const pad = (n) => String(n).padStart(2, "0");
      return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
    },

    goBack() {
      this.$router.push(PAGES.financePaymentCreateForMaster);
    },

    openFilterProjectModal() {
      this.appStore.showSecondaryModal(MODAL_NAMES.SelectSbsProject, {
        title: "Выбор проекта (фильтр)",
        persistent: true,
        onSelect: (project) => {
          if (!project) return;
          this.selectedFilterProject = project;
          this.filters.project_id = project.project_id;
        },
      });
    },
    clearFilterProject() {
      this.selectedFilterProject = null;
      this.filters.project_id = null;
    },

    openCreateProjectModal() {
      this.appStore.showSecondaryModal(MODAL_NAMES.SelectSbsProject, {
        title: "Выбор проекта для исключения",
        persistent: true,
        onSelect: (project) => {
          if (!project) return;
          this.selectedCreateProject = project;
          this.createForm.project_id = project.project_id;
        },
      });
    },
    clearCreateProject() {
      this.selectedCreateProject = null;
      this.createForm.project_id = null;
    },

    async getData() {
      this.isFetching = true;
      try {
        const rows = await readProjectPaymentExclude(this.filters.project_id);
        this.rowsData = rows || [];
      } catch (e) {
        this.rowsData = [];
        this.$q.notify({
          type: "negative",
          message: e?.response?.data?.error || "Ошибка получения данных",
        });
      } finally {
        this.isFetching = false;
      }
    },

    resetFilters() {
      this.clearFilterProject();
      this.filters.only_active = true;
      this.getData();
    },

    async createExclude() {
      this.isCreating = true;
      try {
        const res = await createProjectPaymentExclude({
          project_id: this.createForm.project_id,
          exclude_comment: this.createForm.exclude_comment,
          exclude_date: this.createForm.exclude_date,
        });
        if (res?.error) throw new Error(res.error);

        this.$q.notify({ type: "positive", message: "Проект исключен" });
        this.createForm.exclude_comment = "";
        this.getData();
      } catch (e) {
        this.$q.notify({
          type: "negative",
          message: e?.response?.data?.error || e?.message || "Ошибка создания исключения",
        });
      } finally {
        this.isCreating = false;
      }
    },

    async includeProject(row) {
      try {
        const res = await updateProjectPaymentExclude({
          project_payment_exclude_id: row.project_payment_exclude_id,
          exclude_comment: row.exclude_comment,
          exclude_date: row.exclude_date,
          include_date: this.todayIsoDate(),
        });
        if (res?.error) throw new Error(res.error);
        this.$q.notify({ type: "positive", message: "Проект включен обратно" });
        this.getData();
      } catch (e) {
        this.$q.notify({
          type: "negative",
          message: e?.response?.data?.error || e?.message || "Ошибка обновления",
        });
      }
    },

    openEditDialog(row) {
      this.editDialog.projectLabel = [
        row.project_id ? `#${row.project_id}` : "",
        row.resident_name || "",
        row.project_type_name || "",
      ]
        .filter(Boolean)
        .join(" — ");

      this.editDialog.form = {
        project_payment_exclude_id: row.project_payment_exclude_id,
        exclude_date: row.exclude_date ? String(row.exclude_date).slice(0, 10) : "",
        include_date: row.include_date ? String(row.include_date).slice(0, 10) : "",
        exclude_comment: row.exclude_comment || "",
      };
      this.editDialog.isOpen = true;
    },

    async saveEdit() {
      this.editDialog.isSaving = true;
      try {
        const res = await updateProjectPaymentExclude({
          project_payment_exclude_id: this.editDialog.form.project_payment_exclude_id,
          exclude_comment: this.editDialog.form.exclude_comment,
          exclude_date: this.editDialog.form.exclude_date,
          include_date: this.editDialog.form.include_date || null,
        });
        if (res?.error) throw new Error(res.error);
        this.$q.notify({ type: "positive", message: "Сохранено" });
        this.editDialog.isOpen = false;
        this.getData();
      } catch (e) {
        this.$q.notify({
          type: "negative",
          message: e?.response?.data?.error || e?.message || "Ошибка сохранения",
        });
      } finally {
        this.editDialog.isSaving = false;
      }
    },

    async deleteExclude(row) {
      try {
        const res = await deleteProjectPaymentExclude(row.project_payment_exclude_id);
        if (res?.error) throw new Error(res.error);
        this.$q.notify({ type: "positive", message: "Удалено" });
        this.getData();
      } catch (e) {
        this.$q.notify({
          type: "negative",
          message: e?.response?.data?.error || e?.message || "Ошибка удаления",
        });
      }
    },
  },
  setup() {
    const appStore = useAppStore();
    return { appStore };
  },
};
</script>

<style scoped>
.finance-payment-exclude-projects {
  padding: 20px;
  background: #f8f9fa;
  min-height: 100vh;
}

.filters-section {
  background: white;
  padding: 12px 16px;
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  margin-bottom: 12px;
}

.filters-row {
  display: flex;
  gap: 16px;
  align-items: flex-end;
  flex-wrap: wrap;
}

.filter-item {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 240px;
  flex-shrink: 0;
}

.filter-item--grow {
  flex: 1;
  min-width: 320px;
}

.filter-item label {
  font-size: 10px;
  font-weight: 600;
  color: #9e9e9e;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 0;
}

.filter-with-clear {
  display: flex;
  align-items: center;
  gap: 2px;
}

.filter-input-wrapper {
  cursor: pointer;
}

.filter-input-wrapper--grow {
  width: 100%;
}

.project-input {
  width: 160px;
  cursor: pointer;
}

.project-input--grow {
  width: 100%;
  max-width: 100%;
}

.project-input :deep(.q-field__control) {
  cursor: pointer;
}

.clear-btn {
  margin-left: -6px;
}

.filter-actions {
  display: flex;
  gap: 6px;
  margin-left: auto;
  align-items: flex-end;
}

.filter-actions .q-btn {
  font-size: 12px;
  padding: 4px 12px;
  min-height: 32px;
}

.create-section {
  background: white;
  padding: 14px 16px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  margin-bottom: 12px;
}

.create-title {
  display: flex;
  align-items: center;
  font-weight: 700;
  color: #455a64;
  margin-bottom: 10px;
}

.create-row {
  display: flex;
  gap: 16px;
  align-items: flex-end;
  flex-wrap: wrap;
}

.table-section {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.project-info-cell {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.project-name-row {
  display: flex;
  align-items: center;
}
.resident-name {
  font-weight: 600;
  font-size: 13px;
  color: #1976d2;
}
.project-details-row {
  display: flex;
  align-items: center;
}
.project-id {
  font-size: 11px;
  color: #757575;
}

.exclude-info-cell {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.exclude-line {
  display: flex;
  align-items: center;
  gap: 6px;
}
.exclude-label {
  color: #9e9e9e;
  font-size: 11px;
}
.exclude-date {
  font-weight: 700;
  color: #e65100;
}
.include-date {
  color: #2e7d32;
  font-weight: 600;
}
.active-badge {
  font-size: 11px;
  font-weight: 700;
  color: #ffffff;
  background: #e65100;
  padding: 2px 8px;
  border-radius: 999px;
}

.comment-cell {
  white-space: normal;
  word-break: break-word;
  line-height: 1.3;
}

.who-cell {
  display: flex;
  align-items: center;
}

.actions-cell {
  display: flex;
  justify-content: flex-end;
  gap: 2px;
}

.field-label {
  display: block;
  font-size: 10px;
  font-weight: 600;
  color: #9e9e9e;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 4px;
}
</style>

